// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import '../public/css/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import '../public/css/main.css'
import {getRequest} from './utils/request'
import {postRequest} from './utils/request'
import {postRequestJson} from './utils/request'
import {deleteRequest} from './utils/request'
import {postMultipartRequest} from './utils/request'
import {downloadRequest} from './utils/request'
import {getRequestFile} from './utils/request'
import './utils/filter_utils'
import {initMenu} from './utils/util'
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import cal from '@/utils/calculation';
import 'default-passive-events';
import directives from './utils/directives'


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(directives)
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postRequestJson = postRequestJson;
Vue.prototype.postMultipartRequest = postMultipartRequest;
Vue.prototype.downloadRequest = downloadRequest;
Vue.prototype.getRequestFile = getRequestFile;
/*Vue.prototype.$apiUrl = (process.env.NODE_ENV === 'production') ?
  window.location.protocol + "//" + window.location.hostname +"/console/api" :
  process.env.VUE_APP_API_URL;*/
Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL
Vue.prototype.$baseUrl = process.env.BASE_URL;
Vue.prototype.$webGLExePath = process.env.VUE_APP_WEBGL_EXEPATH;
Vue.prototype.$tinymceUrl = process.env.VUE_APP_TINYMCE_URL;
Vue.prototype.$larkXRUrl = process.env.VUE_APP_LARKXR_URL;
Vue.prototype.cal = cal; // 计算
// 去除掉控制台打印日志
if(process.env.NODE_ENV === 'production') {
  console.log = () => {}
}
router.beforeEach((to, from, next) => {
  //检查是否登录，如果已经登录直接跳转
   var user = store.state.user;
   if(user && user.userId != null){
     if(to.path == '/' || to.path == '/login'){
       next({ path: '/console' });
     }else next();
   }else if (!to.meta.requireLogin) {
     //保存当前路由\
     if (to.path == '/login' && router.currentRoute.fullPath  != '/'
       && router.currentRoute.fullPath  != '/login'
       && router.currentRoute.fullPath  != '/register'
       && router.currentRoute.fullPath  != '/forgetPassword'
       && router.currentRoute.fullPath  != '/register?source=shouyun') {
       localStorage.setItem("preRoute", router.currentRoute.fullPath)
     }
      next();
    }else {
     next();
   }
    initMenu(router, store);
  }
)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
